/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClaimImageDTO } from './ClaimImageDTO';
import type { ClaimShippingDTO } from './ClaimShippingDTO';
export type ClaimCentralDTO = {
    status?: ClaimCentralDTO.status;
    repairOwnerStatus?: ClaimCentralDTO.repairOwnerStatus;
    repairReceiverStatus?: ClaimCentralDTO.repairReceiverStatus;
    noteCancel?: string;
    noteReceive?: string;
    noteApprove?: string;
    noteConfirmProduct?: string;
    ownerShip?: ClaimShippingDTO;
    receiverShip?: ClaimShippingDTO;
    receiverConfirmImages?: Array<ClaimImageDTO>;
};
export namespace ClaimCentralDTO {
    export enum status {
        WAIT_APPROVE = 'WAIT_APPROVE',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
    }
    export enum repairOwnerStatus {
        NONE = 'NONE',
        PREPARE = 'PREPARE',
        SENT = 'SENT',
        CHECK_PRODUCT = 'CHECK_PRODUCT',
        IN_PROGRESS = 'IN_PROGRESS',
        REPAIR_FINISH = 'REPAIR_FINISH',
        WAIT_RECEIVE = 'WAIT_RECEIVE',
        COMPLETE = 'COMPLETE',
        CANCEL = 'CANCEL',
        WAIT_CANCEL = 'WAIT_CANCEL',
        COMPLETE_CANCEL = 'COMPLETE_CANCEL',
    }
    export enum repairReceiverStatus {
        NONE = 'NONE',
        WAIT_PRODUCT = 'WAIT_PRODUCT',
        CHECK_PRODUCT = 'CHECK_PRODUCT',
        IN_PROGRESS = 'IN_PROGRESS',
        REPAIR_FINISH = 'REPAIR_FINISH',
        SENT_PRODUCT = 'SENT_PRODUCT',
        COMPLETE = 'COMPLETE',
        CANCEL = 'CANCEL',
        WAIT_CANCEL = 'WAIT_CANCEL',
        COMPLETE_CANCEL = 'COMPLETE_CANCEL',
    }
}

